import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc76356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-detail-page" }
const _hoisted_2 = { class: "info" }

import { ref } from 'vue'
import DeviceInfo from './components/site-info.vue'
import DeviceMap from './components/site-map.vue'
import { CODE_ENUM } from '@/common'
import { querySiteInfo } from '@/api'
import { useRouter, useRoute } from 'vue-router'
import { isEmpty } from 'lodash'
import SiteDeviceTable from './components/site-device-table.vue'

import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const $route = useRoute()

const deviceMapRef = ref()

const siteId = $route.query.id || ''
const deviceStatusCode: any = $route.query.deviceStatusCode || ''

const siteData: any = ref({})
const queryDetail = async () => {
  const res: any = await querySiteInfo({
    siteId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    siteData.value = res.data

    const { locationLat, locationLong } = res.data
    setTimeout(() => {
      if (!isEmpty(locationLong)) {
        deviceMapRef.value.createMaker({
          longitude: locationLong,
          latitude: locationLat,
        })
      }
    }, 500)
  }
}

queryDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DeviceInfo, { data: siteData.value }, null, 8, ["data"]),
      _createVNode(DeviceMap, {
        ref_key: "deviceMapRef",
        ref: deviceMapRef
      }, null, 512)
    ]),
    _createVNode(SiteDeviceTable, {
      siteId: siteData.value.id,
      deviceStatusCode: _unref(deviceStatusCode)
    }, null, 8, ["siteId", "deviceStatusCode"])
  ]))
}
}

})